import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Invitation, InvitationRequest, InvitationRequestV2 } from '../models/invitation.model';
import { AppConfig } from '../helpers/app.config';

@Injectable({
  providedIn: 'root'
})
export class InvitationService {

  constructor(private httpClient: HttpClient) { }

  sendV2(invitation: InvitationRequestV2): Observable<Invitation> {
    return this.httpClient.post<Invitation>(AppConfig.settings.API + '/v2/tests?origin=ct', invitation);
  }

  sendReminder(invitation: InvitationRequest): Observable<any> {
    return this.httpClient.put<any>(AppConfig.settings.API + '/tests/send/reminder?origin=ct', invitation);
  }

  massiveSend(data): Observable<any> {
    return this.httpClient.post<any>(AppConfig.settings.API + '/tests/send/massive?origin=ct', data);
  }

}
